import './work.scss'
import pCards from './cards/personCards' 
import {useState} from 'react'
import { useEffect, useLayoutEffect } from "react";

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export default function Work() {
  const styles = {
    media: {
      height: 250,
      minWidth: 400,

    }
};


  return (
    <div className='work' id='Team'>
      <div className='title-holder'>
      <h2 className='title'>Team Members</h2>
      <h3 className='title-2'> Meet The Team!</h3>
      <span className='line-2'> </span>
      </div>

      <div className="container">

      <Card sx={{ minWidth: 400,
      margin:'2rem'}}>
      <CardMedia
        component="img"
        style={styles.media} 
     
        image={require('./stick.jpg')}
        alt={'kusha'}
      />

      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          Kusha Sareen
        </Typography>
        <Typography variant="body2" color="text.secondary">
          SWAPPR COPORATE DRONE | ID:176439
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" sx={{
                  color: '#000',
                  borderColor: "#000",
                  boxShadow: 'none',
                  ':hover': {
                    bgcolor: "#000", 
                    color: 'white',
                  }

                }}><a id='buh' target='_blank' href="https://p5js.org/reference/" underline="none">Learn More </a></Button>
      </CardActions>
    </Card>



      

  

    <Card sx={{ minWidth: 400,
      margin:'2rem'}}>
      <CardMedia
        component="img"
        style={styles.media} 
     
        image={require('./stick.jpg')}
        alt={'kusha'}
      />

      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          Mark Daniel
        </Typography>
        <Typography variant="body2" color="text.secondary">
         SWAPPR COPORATE DRONE | ID:#190439
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" sx={{
                  color: '#000',
                  borderColor: "#000",
                  boxShadow: 'none',
                  ':hover': {
                    bgcolor: "#000", 
                    color: 'white',
                  }
                  

                }}><a id='buh' target='_blank' href="https://mysticalnumbers.com/number-8/" underline="none">Learn More </a></Button>
      </CardActions>
    </Card>

    </div>
    
    <div id="footer" class="sized content">
      
    {/* <p>© November 2022 </p> */}
    
  </div>
    </div>
  )
}
